import { api, endpoints } from "api/api";
import { TopicApi, TopicAppearanceApi } from "api/topics/topicsApi";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string,
  orderBy: string
): AxiosPromise<BaseApiPaging<TopicGroupApi>> => {
  return api.get<BaseApiPaging<TopicGroupApi>>(endpoints.TOPIC_GROUPS.GET(skip, take, searchPhrase, filter, orderBy));
};
const fetchById = (topicId: number): AxiosPromise<TopicGroupApi> => {
  return api.get<TopicGroupApi>(endpoints.TOPIC_GROUPS.GET_BY_ID(topicId));
};

const featchAppearances = (topicId: number): AxiosPromise<TopicAppearanceApi> => {
  return api.get<TopicAppearanceApi>(endpoints.TOPIC_GROUPS.GET_APPEARANCES(topicId));
};
const create = (data: CreateGroupRequest): AxiosPromise<TopicApi> => {
  // TODO TopicApi?
  return api.post<TopicApi>(endpoints.TOPIC_GROUPS.CREATE(), data);
};

const update = (topicId: number, data: CreateGroupRequest): AxiosPromise => {
  return api.put(endpoints.TOPIC_GROUPS.UPDATE(topicId), data);
};
const deleteTopicGroup = (topicId: number): Promise<void> => {
  return api.delete(endpoints.TOPIC_GROUPS.DELETE(topicId));
};

export const topicgroupsApi = {
  fetch,
  featchAppearances,
  fetchById,
  create,
  update,
  delete: deleteTopicGroup,
};

export interface TopicGroupCourseGroupApi {
  courseGroupId: number;
  name: string;
}

export interface TopicGroupApi {
  id: number;
  name: string;
  time: number;
  topics: TopicApi[];
  courseGroups: TopicGroupCourseGroupApi[];
}

interface CreateGroupRequest {
  name: string;
  groupTime?: number;
  courseGroupIds?: number[];
  topics: {
    id: number;
    time?: number;
  }[];
}
